<script setup>
  import { toRefs } from "vue";
  import { Input } from "@/components/ui/input";
  import { getCountryName } from "@utils/constants/regions";
  import { formatInputValue, parseInputValue } from "@utils/formatters";

  const props = defineProps({
    field: { type: Object, required: true },
    countryData: { type: Object, required: true },
  });

  const { field, countryData } = toRefs(props);
</script>

<template>
  <div class="flex items-center gap-12">
    <div class="flex-1 flex items-center gap-4">
      <div class="flex h-8 w-1/2 items-center rounded-md border border-input bg-muted px-3 text-13 text-foreground-secondary">
        {{ getCountryName(countryData.country) }}
      </div>
      <div :class="field.type === 'number' && field.max != null && field.max <= 100 ? 'w-24' : 'flex-1'">
        <Input
          v-model="countryData[field.name]"
          :type="field.type === 'number' ? 'number' : 'text'"
          :min="field.min"
          :max="field.max"
          :placeholder="field.placeholder" />
      </div>
    </div>
    <div class="flex items-center gap-4">
      <div class="w-20">
        <Input
          v-model="countryData[`${field.name}_auto`]"
          class="text-center text-muted-foreground border-dashed border-1"
          readonly />
      </div>
      <div class="w-20">
        <Input
          :model-value="formatInputValue(countryData[`${field.name}_manual`])"
          class="text-center"
          @update:model-value="countryData[`${field.name}_manual`] = parseInputValue($event)" />
      </div>
    </div>
  </div>
</template>
